<script lang="ts">
	import type { Snippet } from 'svelte';
	import type {
		HDGoalkeeperStats,
		HDPlayerStats,
		HDTeamRosterPlayer
	} from '../types/responses/TeamDetails.js';
	import { calcTime } from '../hockeydata.js';

	export interface HDPlayerCardProps {
		player: HDTeamRosterPlayer & Partial<HDPlayerStats> & Partial<HDGoalkeeperStats>;
		title?: string;
		showStats?: boolean;
		children?: Snippet;
		badges?: Snippet;
	}

	const { player, title, showStats, children, badges }: HDPlayerCardProps = $props();
</script>

<div class="bg-base-100 flex w-full max-w-75 flex-col">
	{#if title}
		<h2>{title}</h2>
	{/if}
	<img
		src={player.images.playerSmallPortrait}
		alt={player.playerLastname}
		class="aspect-3/4 object-cover"
	/>
	<div class="border-accent flex flex-col border-t-2 p-3">
		<div class="flex items-center justify-between text-xl">
			<div class="my-1 flex items-center gap-3">
				<span
					class="text-base-100 text-shadow shadow-accent text-4xl font-black tracking-wider uppercase"
					>{player.playerJerseyNr}</span
				>
				{player.playerFirstname}
				{player.playerLastname}
			</div>
			<div class="bg-base-100 rounded-xl">
				{#if badges}
					{@render badges()}
				{/if}
			</div>
		</div>
		<div class="border-accent flex flex-col border-l-4 pl-2">
			{#if showStats}
				{#if player.position === 'G'}
					<div>
						Zeit am Eis: {calcTime(player.playingTime ?? 0)}
					</div>
					<div>
						Shutouts: {player.shutOuts}
					</div>
				{:else}
					<div>
						Punkte: {player.points}
					</div>
					<div>
						Goals: {player.goals}
					</div>
					<div>
						Assists: {player.assists}
					</div>
					<div>
						PIM: {player.penaltyMinutes}
					</div>
				{/if}
			{/if}
			{#if children}
				{@render children()}
			{/if}
		</div>
	</div>
</div>
